import { render, staticRenderFns } from "./TestSourceModal.vue?vue&type=template&id=884ca710&"
import script from "./TestSourceModal.vue?vue&type=script&lang=js&"
export * from "./TestSourceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports